export class Htmlconverter {
    html1:string;
}
